import React from 'react'
import Link from '../PageComponents/Link'
export default function TButton ({ title, url }) {
  return (
    <div className='flex lg:inline-flex px-6 lg:px-0'>
      <Link
        className='font-medium cursor-pointer uppercase btn btn_white text-center py-3 btn_sm w-full px-8'
        url={url}
      >
        {title}
      </Link>
    </div>
  )
}
